import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";


const EditPurchased = () => {

    const [selectedClient, setSelectedClient] = useState('');
    const [clients, setClients] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');

    const [userPacking, setUserPacking] = useState(null);
    const [userNetWeight, setUserNetWeight] = useState(null);
    const [userQuantity, setUserQuantity] = useState(null);

    const [totalWeight, setTotalWeight] = useState(null);
    const [userShortage, setUserShortage] = useState(0);

    const [dataPrice, setDataPrice] = useState(null);
    const [dataTotalPrice, setDataTotalPrice] = useState(null);

    const navigate = useNavigate();

    const [inputs, setInputs] = useState([]);

    const { id } = useParams();

    useEffect(() => {
        getUser();

        fetch('https://react-apis.dotlocalhost.com/purchase.php')
            .then(response => response.json())
            .then(data => setUsers(data))
            .catch(error => console.error('Error fetching users:', error));

        fetch('https://react-apis.dotlocalhost.com/dropclient.php')
            .then(response => response.json())
            .then(data => setClients(data))
            .catch(error => console.error('Error fetching client names:', error));

    }, []);

    // Fetch the last name of the selected user
    const handleUserChange = (event) => {
        const ProName = event.target.value;
        setSelectedUser(ProName);
        if (ProName) {
            fetch(`https://react-apis.dotlocalhost.com/purchase.php?productName=${ProName}`)
                .then(response => response.json())
                .then(data => setUserPacking(data.packing) | setUserNetWeight(data.netWeight) | setUserQuantity(userQuantity) | setTotalWeight(totalWeight) | setUserShortage(userShortage))
                //.then(data => setUserNetWeight(data.netWeight))
                .catch(error => console.error('Error fetching packing:', error));
        } else {
            setUserPacking(null);
            setUserNetWeight(null);
            setUserQuantity(null);
            setTotalWeight(null);
            setUserShortage(null);

        }
    };


    const handleClientChange = (event) => {
        setSelectedClient(event.target.value);
    };

    useEffect(() => {
        const calculateTotalWeight = () => {
        const total = (userNetWeight * userQuantity) - userShortage;
        setTotalWeight(total);
        const total2 = totalWeight * dataPrice;
        setDataTotalPrice(total2);
        };
        calculateTotalWeight();
    }, [userNetWeight, userQuantity, userShortage, totalWeight, dataPrice]);

    function getUser() {
        axios.get(`https://react-apis.dotlocalhost.com/purchaseShow.php/${id}`).then(function (response) {
            console.log(response.data);
            setInputs(response.data);
        });
    }

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setInputs(values => ({ ...values, [name]: value }));
    }
    const handleSubmit = (event) => {
        event.preventDefault();

        axios.put(`https://react-apis.dotlocalhost.com/purchaseShow.php/${id}/edit`, inputs).then(function (response) {
            console.log(response.data);
            alert('Record have been updated succefully!');
            navigate('/Purchased');
        });
    }

    return (
        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Edit Purchased Items</h3>
                        </div>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <Table cellSpacing="10">
                            <tbody>
                                <tr>
                                    <th>
                                        <label>Client Name: </label>
                                    </th>
                                    <td>
{/*                                         
                                        <select id="clientDropdown" name="clientName" value={selectedClient} className='form-control' onChange={handleClientChange}>
                                            <option value="">{inputs.clientName}</option>
                                            {clients.map((client, index) => (
                                                <option key={index} value={client}>{client}</option>
                                            ))}
                                        </select>
*/}                                         
                                        <input value={inputs.clientName} readOnly type="text" className='form-control' name="clientName" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Shipping Mark: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.shipping_mark} type="text" className='form-control' name="shipping_mark" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Purchage ID: </label>
                                    </th>
                                    <td>
                                        <input value={inputs.purchage_Id} readOnly type="text" className='form-control' name="purchage_Id" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Product Name: </label>
                                    </th>
                                    <td>
{/*                                        
                                        <select value={selectedUser} className='form-control' name="productName" onChange={handleUserChange}>
                                            <option value="">{inputs.productName}</option>
                                            {users.map(data => (
                                                <option key={data.productName} value={data.productName}>{data.productName}</option>
                                            ))}
                                        </select>
*/}                                     <input value={inputs.productName} readOnly type="text" className='form-control' name="purchage_Id" onChange={handleChange} />
                                    </td>
                                </tr>

                                <tr>
                                    <th>
                                        <label>Packing: </label>
                                    </th>
                                    <td>
{/*                                        
                                        {selectedUser === '' && (
                                        <input  value={inputs.packing} type="text" name="packing" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="packing" className='form-control' onChange={handleChange} value={userPacking} />
                                        )}
*/}                                       
                                        <input value={inputs.packing} readOnly type="text" className='form-control' name="purchage_Id" onChange={handleChange} />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Net Weight: </label>
                                    </th>
                                    <td>
                                        {selectedUser === '' && (
                                        <input value={inputs.netWeight} type="text" name="netWeight" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="netWeight" className='form-control' onChange={(e) => setUserNetWeight(Number(e.target.value))} value={userNetWeight} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Quantity: </label>
                                    </th>
                                    <td>
                                        {selectedUser === '' && (
                                        <input value={inputs.quantity} type="text" name="quantity" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="quantity" className='form-control' onChange={(e) => setUserQuantity(Number(e.target.value))} value={userQuantity} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Shortage: </label>
                                    </th>
                                    <td>
                                        {selectedUser === '' && (
                                        <input value={inputs.shortage} type="text" name="shortage" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="shortage" className='form-control' onChange={(e) => setUserShortage(Number(e.target.value))} value={userShortage} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>Total Weight: </label>
                                    </th>
                                    <td>
                                        {selectedUser === '' && (
                                        <input value={inputs.totalWeight} type="text" name="totalWeight" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="totalWeight" className='form-control' value={totalWeight} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>price: </label>
                                    </th>
                                    <td>
                                        {selectedUser === '' && (
                                        <input value={inputs.price} type="text" name="price" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="price" className='form-control' onChange={(e) => setDataPrice(Number(e.target.value))} value={dataPrice} />
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <label>total Bill: </label>
                                    </th>
                                    <td>
                                        {selectedUser === '' && (
                                        <input value={inputs.totalBill} type="text" name="totalBill" className='form-control' onChange={handleChange} />
                                        )}
                                        {selectedUser !== '' && (
                                        <input type="text" name="totalPrice" className='form-control' value={dataTotalPrice} />
                                        )}
                                    </td>
                                </tr>


                                <tr>
                                    <td colSpan="2" align="right">
                                        <Link to={`/Purchased`} style={{ marginRight: "10px" }} class="btn btn-warning">Cancle Edit</Link>
                                        <button class="btn btn-success">Update</button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </form>

                </div>

            </div>
        </div>
    )
}

export default EditPurchased;